import { ActionButton, Box } from '@joinrepublic/dls-ui-kit';
import { observer } from 'mobx-react-lite';

import { ISocialAuthSource } from './social-auth-sources';

export interface ISocialAuthButtonProps {
  socialAuthSource: ISocialAuthSource;
  disabled: boolean;
}

export const SocialAuthButton = observer(function SocialAuthButton({
  socialAuthSource,
  disabled,
}: ISocialAuthButtonProps) {
  const { providerName, displayName, Icon } = socialAuthSource;

  const getIconStyles = () => {
    switch (providerName) {
      case 'apple':
        return {
          width: '31px',
          height: '28.5px',
          marginTop: '-1px',
          marginLeft: '0px',
        };
      case 'google':
        return {
          width: '26px',
          height: '23px',
          marginTop: '4px',
          marginLeft: '6px',
        };
      default:
        return {
          width: '22px',
          height: '22px',
          marginTop: '0px',
          marginLeft: '2px',
        };
    }
  };

  const iconStyles = getIconStyles();

  return (
    <Box flexGrow="1">
      <ActionButton
        variant="secondary"
        leftIcon={
          <Box
            width="26px"
            height="26px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            overflow="hidden"
            position="relative"
          >
            <Icon
              width={iconStyles.width}
              height={iconStyles.height}
              marginTop={iconStyles.marginTop}
              marginLeft={iconStyles.marginLeft}
              filter="grayscale(1) brightness(0)"
              style={{ maxWidth: 'none', maxHeight: 'none' }}
            />
          </Box>
        }
        width="100%"
        height="12"
        aria-label={`Continue with ${displayName}`}
        title={`Continue with ${displayName}`}
        name="provider"
        type="submit"
        value={providerName}
        isDisabled={disabled}
        cursor={disabled ? 'not-allowed' : 'pointer'}
        form="social-auth-form"
      />
    </Box>
  );
});
